// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: kvajJ2MSr9DNMA2u1PusCw
// Component: ItAMwN5qPyr
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import projectcss from "./plasmic_blank_project.module.css"; // plasmic-import: kvajJ2MSr9DNMA2u1PusCw/projectcss
import sty from "./PlasmicFileActions.module.css"; // plasmic-import: ItAMwN5qPyr/css
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: YMxVesaEXe/icon

createPlasmicElementProxy;

export const PlasmicFileActions__VariantProps = new Array("page");

export const PlasmicFileActions__ArgProps = new Array();

const $$ = {};

function PlasmicFileActions__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "page",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.page
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (hasVariant($state, "page", "upload") ? true : false) ? (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        sty.root,
        { [sty.rootpage_upload]: hasVariant($state, "page", "upload") }
      )}
    >
      <div
        data-plasmic-name={"fileName"}
        data-plasmic-override={overrides.fileName}
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.fileName
        )}
      >
        {"Enter some text"}
      </div>
      <IconIcon
        data-plasmic-name={"removeBtn"}
        data-plasmic-override={overrides.removeBtn}
        className={classNames(projectcss.all, sty.removeBtn, {
          [sty.removeBtnpage_upload]: hasVariant($state, "page", "upload")
        })}
        role={"img"}
      />
    </div>
  ) : null;
}

const PlasmicDescendants = {
  root: ["root", "fileName", "removeBtn"],
  fileName: ["fileName"],
  removeBtn: ["removeBtn"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicFileActions__ArgProps,
          internalVariantPropNames: PlasmicFileActions__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicFileActions__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicFileActions";
  } else {
    func.displayName = `PlasmicFileActions.${nodeName}`;
  }
  return func;
}

export const PlasmicFileActions = Object.assign(
  // Top-level PlasmicFileActions renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    fileName: makeNodeComponent("fileName"),
    removeBtn: makeNodeComponent("removeBtn"),
    // Metadata about props expected for PlasmicFileActions
    internalVariantProps: PlasmicFileActions__VariantProps,
    internalArgProps: PlasmicFileActions__ArgProps
  }
);

export default PlasmicFileActions;
/* prettier-ignore-end */
